// extracted by mini-css-extract-plugin
export var container = "_rj-0";
export var dotAnimation = "_rj-2";
export var dotsLoading = "_rj-1";